module.exports = __webpack_public_path__ + "static/img/xtf.95c2efc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xtf.png
// module id = nJLF
// module chunks = 0